var formulajs = require('formulajs');
import moment from "moment";
import business from 'moment-business';

module.exports = function () {
  window.YieldNSS = function (beta1, beta2, beta3, beta4, lambda1, lambda2, a2) {
    return (beta1)
      + (beta2 * ((1 - Math.exp(-a2 / lambda1)) / (a2 / lambda1)))
      + (beta3 * ((((1 - Math.exp(-a2 / lambda1)) / (a2 / lambda1)))
        - (Math.exp(-a2 / lambda1))))
      + (beta4 * ((((1 - Math.exp(-a2 / lambda2)) / (a2 / lambda2))) - (Math.exp(-a2 / lambda2))));
  };
  window.yieldnss = window.YIELDNSS;

  window.ABS = Math.abs;
  window.abs = Math.abs;

  window.ACOS = Math.acos;
  window.acos = Math.acos;

  window.ACOSH = Math.acosh;
  window.acosh = Math.acosh;

  window.ASIN = Math.asin;
  window.asin = Math.asin;

  window.ATAN = Math.atan;
  window.atan = Math.atan;

  window.ATANH = Math.atanh;
  window.atanh = Math.atanh;

  window.ATANH2 = Math.atanh2;
  window.atanh2 = Math.atanh2;

  window.avg = function (...values) {
    return values.reduce((a, b) => a + b, 0) / values.length;
  };

  window.AVG = window.avg;

  window.CBRT = Math.cbrt;
  window.cbrt = Math.cbrt;

  window.CEILING = Math.ceil;
  window.ceiling = Math.ceil;

  window.COS = Math.cos;
  window.cos = Math.cos;

  window.COSH = Math.cosh;
  window.cosh = Math.cosh;

  window.EXP = Math.exp;
  window.exp = Math.exp;

  window.FLOOR = Math.floor;
  window.floor = Math.floor;

  window.ISEVEN = function (v) {
    return v % 2 === 0;
  };
  window.iseven = window.ISEVEN;

  window.ISODD = function (v) {
    return v % 2 !== 0;
  };
  window.isodd = window.ISODD;

  window.LN = Math.log;
  window.ln = Math.log;

  window.LOG = function (v, base) {
    return Math.log(v) / Math.log(base);
  };
  window.log = window.LOG;

  window.LOG10 = Math.log10;
  window.log10 = Math.log10;

  window.MAX = Math.max;
  window.max = Math.max;

  window.MIN = Math.min;
  window.min = Math.min;

  window.MOD = function (dividend, divisor) {
    return dividend % divisor;
  };
  window.mod = Math.MOD;

  window.POWER = Math.pow;
  window.power = Math.pow;

  window.PI = Math.PI;
  window.pi = Math.PI;

  window.RAND = Math.random;
  window.rand = Math.random;

  window.ROUND = function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
  };

  window.round = window.ROUND;

  window.SIN = Math.sin;
  window.sin = Math.sin;

  window.SINH = Math.sinh;
  window.sinh = Math.sinh;

  window.SQRT = Math.sqrt;
  window.sqrt = Math.sqrt;

  window.TAN = Math.tan;
  window.tan = Math.tan;

  window.TANH = Math.tanh;
  window.tanh = Math.tanh;

  window.SUM = function () {
    var result = 0;
    for (var i = 0; i < arguments.length; i++) {
      result += arguments[i];
    }
    return result;
  };
  window.sum = window.SUM;

  // financial related

  window.ACCRINT = formulajs.ACCRINT;
  window.accrint = formulajs.ACCRINT;

  window.CUMIPMT = formulajs.CUMIPMT;
  window.cumipmt = formulajs.CUMIPMT;

  window.CUMPRINC = formulajs.CUMPRINC;
  window.cumprinc = formulajs.CUMPRINC;

  window.DB = formulajs.DB;
  window.db = formulajs.DB;

  window.DDB = formulajs.DDB;
  window.ddb = formulajs.DDB;

  window.DOLLARDE = formulajs.DOLLARDE;
  window.dollarde = formulajs.DOLLARDE;

  window.DOLLARFR = formulajs.DOLLARFR;
  window.dollarfr = formulajs.DOLLARFR;

  window.EFFECT = formulajs.EFFECT;
  window.effect = formulajs.EFFECT;

  window.FV = formulajs.FV;
  window.fv = formulajs.FV;

  window.FVSCHEDULE = formulajs.FVSCHEDULE;
  window.fvschedule = formulajs.FVSCHEDULE;

  window.IPMT = formulajs.IPMT;
  window.ipmt = formulajs.IPMT;

  window.IRR = formulajs.IRR;
  window.irr = formulajs.IRR;

  window.ISPMT = formulajs.ISPMT;
  window.ispmt = formulajs.ISPMT;

  window.MIRR = formulajs.MIRR;
  window.mirr = formulajs.MIRR;

  window.NOMINAL = formulajs.NOMINAL;
  window.nominal = formulajs.NOMINAL;

  window.NPER = formulajs.NPER;
  window.nper = formulajs.NPER;

  window.NPV = formulajs.NPV;
  window.npv = formulajs.NPV;

  window.PDURATION = formulajs.PDURATION;
  window.pduration = formulajs.PDURATION;

  window.PMT = formulajs.PMT;
  window.pmt = formulajs.PMT;

  window.PPMT = formulajs.PPMT;
  window.ppmt = formulajs.PPMT;

  window.PV = formulajs.PV;
  window.pv = formulajs.PV;

  window.RATE = formulajs.RATE;
  window.rate = formulajs.RATE;

  window.RRI = formulajs.RRI;
  window.pri = formulajs.RRI;

  window.SLN = formulajs.SLN;
  window.sln = formulajs.SLN;

  window.SYD = formulajs.SYD;
  window.syd = formulajs.SYD;

  window.TBILLEQ = formulajs.TBILLEQ;
  window.tbilleq = formulajs.TBILLEQ;

  window.TBILLPRICE = formulajs.TBILLPRICE;
  window.tbillprice = formulajs.TBILLPRICE;

  window.TBILLYIELD = formulajs.TBILLYIELD;
  window.tbillyield = formulajs.TBILLYIELD;

  window.XIRR = formulajs.XIRR;
  window.xirr = formulajs.XIRR;

  window.XNPV = formulajs.XNPV;
  window.xnpv = formulajs.XNPV;


  // date related

  window.DATE = formulajs.DATE;
  window.date = formulajs.DATE;

  window.DATEVALUE = formulajs.DATEVALUE;
  window.datevalue = formulajs.DATEVALUE;

  window.DAY = formulajs.DAY;
  window.day = formulajs.DAY;

  window.DAYS360 = formulajs.DAYS360;
  window.days360 = formulajs.DAYS360;

  window.EDATE = formulajs.EDATE;
  window.edate = formulajs.EDATE;

  window.EOMONTH = formulajs.EOMONTH;
  window.eomonth = formulajs.EOMONTH;

  window.HOUR = formulajs.HOUR;
  window.hour = formulajs.HOUR;

  window.MONTH = formulajs.MONTH;
  window.month = formulajs.MONTH;
  //
  // window.DATEVALUE = formulajs.DATEVALUE;
  // window.datevalue = formulajs.DATEVALUE;
  //
  // window.DATEVALUE = formulajs.DATEVALUE;
  // window.datevalue = formulajs.DATEVALUE;
  //
  // window.DATEVALUE = formulajs.DATEVALUE;
  // window.datevalue = formulajs.DATEVALUE;
  //
  // window.DATEVALUE = formulajs.DATEVALUE;
  // window.datevalue = formulajs.DATEVALUE;
  //
  // window.DATEVALUE = formulajs.DATEVALUE;
  // window.datevalue = formulajs.DATEVALUE;


  window.now = function () {
    return moment().toISOString();
  };

  window.setTime = function (date, time) {
    const target = moment(date);
    const source = moment(time);
    target.set({
      hour: source.get('hour'),
      minute: source.get('minute'),
      second: source.get('second'),
      millisecond: source.get('millisecond'),
    });
    return target.toISOString();
  };

  window.addDay = function (date, days) {
    const target = moment(date);
    target.add(days, 'days');
    return target.toISOString();
  }

  window.addBusinessDay = (date, days) => {
    const m = moment(date);
    business.addWeekDays(m, days);
    return m.toISOString();
  }

  window.getNoOfDays = (from, to) => {
    return moment(to).diff(moment(from), 'days');
  }

  window.getNoOfBusinessDays = (from, to) => {
    return business.weekDays(moment(from), moment(to));
  }

  window.startOfMonth = (month, year) => {
    const m = moment(`${year}-${month}-01 00:00:00.000`);
    return m.startOf('month').toISOString();
  }

  window.endOfMonth = (month, year) => {
    const m = moment(`${year}-${month}-01 00:00:00.000`);
    return m.endOf('month').toISOString();
  }

  // UTILS
  window.isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  window.IF = (condition, trueValue, falseValue) => {
    return condition ? trueValue : falseValue;
  }
}();


// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/functions.js